"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbTable = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _value = require("../../skybase-core/utils/value");

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-array-index-key */
var SbTable = function SbTable(_ref) {
  var className = _ref.className,
      id = _ref.id,
      data = _ref.data,
      onRowClick = _ref.onRowClick,
      _ref$metadata = _ref.metadata,
      columnGroups = _ref$metadata.columns,
      groupProperty = _ref$metadata.groupProperty,
      rowProperty = _ref$metadata.rowProperty,
      _ref$metadata$selecte = _ref$metadata.selectedRows,
      selectedRows = _ref$metadata$selecte === void 0 ? [] : _ref$metadata$selecte,
      containerStyle = _ref.containerStyle,
      innerContainerStyle = _ref.innerContainerStyle,
      stickyHeader = _ref.stickyHeader,
      style = _ref.style;
  var containerClassName = (0, _classnames.default)('sb-table-container', {
    'sb-table-sticky-header': stickyHeader
  }, className);
  var containerStyles = Object.assign({}, containerStyle, style);
  var previousGroupValue;
  var groupIndex = 1;
  var fullColIndex;

  if (columnGroups) {
    if (!(columnGroups[0] instanceof Array)) {
      columnGroups = [columnGroups];
    }
  } else if (data[0]) {
    columnGroups = [Object.keys(data[0]).map(function (col) {
      return {
        title: col,
        field: col
      };
    })];
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClassName,
    id: id,
    style: containerStyles
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-table-inner-container",
    style: innerContainerStyle
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: "sb-table"
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: "row-header"
  }, columnGroups.map(function (columns, colGroupIndex) {
    return columns.map(function (col, colIndex) {
      return /*#__PURE__*/_react.default.createElement("th", {
        key: "".concat(id || '', "thead-th-").concat(colGroupIndex, "-").concat(colIndex),
        className: (0, _utils.getClassNameForCell)(colIndex, colGroupIndex)
      }, col.title, stickyHeader && /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-table-sticky-div"
      }, col.title));
    });
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, data.map(function (rowData, rowIndex) {
    var rowClass = "row-content row-".concat((0, _utils.getEvenOddClassName)(rowIndex));

    if (groupProperty) {
      if (rowData[groupProperty] !== previousGroupValue) {
        groupIndex += 1;
        previousGroupValue = rowData[groupProperty];
      }

      rowClass += " row-group-".concat((0, _utils.getEvenOddClassName)(groupIndex));
    }

    var selected = false;
    rowProperty = rowProperty || _constants.defaultRowProperty;

    if (!(0, _value.isNullOrUndefined)(rowData[rowProperty])) {
      selected = (0, _utils.isSelected)(selectedRows, rowData[rowProperty]);
    }

    var trClassName = (0, _classnames.default)(rowClass, {
      selected: selected
    });
    fullColIndex = 0;
    return /*#__PURE__*/_react.default.createElement("tr", {
      className: trClassName,
      key: "".concat(id || '', "tbody-tr-").concat(rowIndex),
      onClick: function onClick() {
        return onRowClick(rowData);
      }
    }, columnGroups.map(function (columns, colGroupIndex) {
      return columns.map(function (col, colInGroupIndex) {
        fullColIndex += 1;
        var val = rowData[col.field];
        var displayText = col.renderer ? col.renderer(val, rowData) : val;
        return /*#__PURE__*/_react.default.createElement("td", {
          key: "".concat(id || '', "tbody-td-").concat(rowIndex, "-").concat(colGroupIndex, "-").concat(colInGroupIndex),
          className: (0, _utils.getClassNameForCell)(colInGroupIndex, colGroupIndex, fullColIndex)
        }, displayText);
      });
    }));
  }), /*#__PURE__*/_react.default.createElement("tr", {
    className: "row-summary"
  }, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: columnGroups.reduce(function (prev, columns) {
      return prev + columns.length;
    }, 0)
  }))))));
};

exports.SbTable = SbTable;
SbTable.propTypes = {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line
  containerStyle: _propTypes.default.object,
  // eslint-disable-line
  innerContainerStyle: _propTypes.default.object,
  // eslint-disable-line
  data: _propTypes.default.arrayOf(_propTypes.default.object),
  metadata: _propTypes.default.shape({
    columns: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
    groupProperty: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    rowProperty: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    selectedRows: _propTypes.default.array
  }).isRequired,
  stickyHeader: _propTypes.default.bool,
  onRowClick: _propTypes.default.func
};
SbTable.defaultProps = {
  className: null,
  id: null,
  style: null,
  containerStyle: {},
  innerContainerStyle: {},
  data: [],
  stickyHeader: false,
  onRowClick: function onRowClick() {}
};
//# sourceMappingURL=sb-table.js.map